import styled, { css } from 'styled-components';
import Typography from '../../typography';
import { STATIC_BASE_URL, pxToRem } from '../../../design-tokens/style-utilities';
/**
 * Sticker
 */
const informationalVariantStyles = ({ theme }) => css `
	background-color: ${theme.colors.accent.bgStickerInformative};

	.PONCHO-icon--jumbo {
		font-size: ${pxToRem(43.5)};
	}

	@media (min-width: ${pxToRem(theme.viewportBreakpoint.md)}) {
		.PONCHO-icon--jumbo {
			font-size: ${pxToRem(53)};
		}
	}
`;
const promotionalAndHeaderVariantStyles = ({ theme }) => css `
	background-color: ${theme.colors.promotional.bgSticker};

	${StickerLine} {
		color: ${theme.colors.blanc.textSticker};
	}
`;
const ratingVariantStyles = ({ theme }) => css `
	background-color: ${theme.colors.blanc.bgSticker};
	border: ${theme.borderWidth[2]}px solid ${theme.colors.base.borderSticker};

	${StickerLine} {
		font-size: ${pxToRem(theme.typography.numbersPricesAndUsPs['200StickerTextNumberS'].fontSize)};

		@media (min-width: ${pxToRem(theme.viewportBreakpoint.md)}) {
			font-size: ${pxToRem(theme.typography.numbersPricesAndUsPs['400StickerTextNumberM'].fontSize)};
		}
	}
`;
const getStickerContainerVariantStyles = ({ variant }) => ({
    informational: informationalVariantStyles,
    promotional: promotionalAndHeaderVariantStyles,
    header: promotionalAndHeaderVariantStyles,
    rating: ratingVariantStyles,
})[variant];
export const StickerContainerStyles = ({ theme, variant, withSpeechBubble, }) => css `
	display: block;
	padding: 0 ${pxToRem(5)};
	border-radius: ${theme.borderRadius.rounded}%;
	text-align: center;
	width: ${pxToRem(theme.stickerSize.mobile)};
	aspect-ratio: 1 / 1;

	@media (min-width: ${pxToRem(theme.viewportBreakpoint.md)}) {
		width: ${pxToRem(theme.stickerSize.desktop)};
	}

	${withSpeechBubble &&
    css `
		mask: url('${STATIC_BASE_URL}/poncho/sticker/images/speechbubble.svg') no-repeat center;

		/* Offset for the speech bubble tab */
		width: ${pxToRem(Number(theme.stickerSize.mobile) + Number(theme.spacing['100']))};
		height: ${pxToRem(Number(theme.stickerSize.mobile) + Number(theme.spacing['100']))};

		@media (min-width: ${pxToRem(theme.viewportBreakpoint.md)}) {
			width: ${pxToRem(Number(theme.stickerSize.desktop) + Number(theme.spacing['100']))};
			height: ${pxToRem(Number(theme.stickerSize.desktop) + Number(theme.spacing['100']))};
		}
	`}

	${getStickerContainerVariantStyles({
    variant,
})}
`;
export const StickerContainer = styled.div `
	${StickerContainerStyles}
`;
/**
 * Sticker body
 */
export const stickerBodyStyles = () => css `
	align-items: center;
	display: flex;
	flex-direction: column;
	justify-content: center;
	height: 100%;
`;
export const StickerBody = styled(Typography).attrs({
    variant: 'sticker-text-md',
}) `
	${stickerBodyStyles}
`;
/**
 * Sticker line
 */
export const stickerLineStyles = ({ $size }) => css `
	/* The higher specificity is needed to override form styles */
	&&& {
		display: block;
		align-self: center;
		margin: 0;
		padding: 0;

		${$size === 2 &&
    css `
			padding-bottom: 1.5px;
		`}

		${$size === 3 &&
    css `
			padding-bottom: 2.5px;
		`}
	}
`;
export const StickerLine = styled(Typography) `
	${stickerLineStyles}
`;
